import React from "react";
import SvgIconDPC from "./dpc-svg-icon";
import moment from "moment";
import "moment/locale/it";
import {AllegatoDPC, LinksContainerDPC, LinksDPC, LinkUtiliDPC} from "../index";

export default class DpcAgenda extends React.Component {

    constructor(props) {
        super(props);
        if (props.locale === "it" || props.locale === "en")
            moment.locale(props.locale);
        this.lastYear = moment().subtract(1, "year");
        this.state = {moment: moment().startOf("month")};
    }

    previous() {
        /**
         * DPCPI-203 chiede di limitare gli eventi mostrati in agenda nel solo utlimo anno:
         * a tal proposito è stato predisposto un filter in fase di render, per di più qui viene
         * bloccato il tasto indietro oltre un anno nel passato, per ripristinare lo scorrere
         * dell'agenda nel passato oltre un anno, togliere questo if
         */
        if (this.state.moment.isSame(this.lastYear, "month"))
            return;
        this.setState((state) => {
            return {moment: state.moment.subtract(1, "months")};
        });
    }

    next() {
        this.setState((state) => {
            return {refDay: state.moment.add(1, "months")};
        });
    }

    getSlug(slug, portaleAttuale, portaleContenuto) {
        let path = "";
        if (portaleAttuale === portaleContenuto)
            path = slug;
        else if (portaleContenuto) {
            const propsName = portaleContenuto.toUpperCase() === 'PORTALE'
                ? 'PORTALE_URL'
                : `MINISITO_${portaleContenuto.toUpperCase().replace(new RegExp("\\s", "g"), '_')}_URL`

            path = this.props.minisiti[propsName] + slug;
        }
        return path;
    }

    getLink(data) {
        if (!data.node?.field_link_esterno && data.node.relationships?.field_link_interno) {
            return `<a href="${this.getSlug('/' + this.props.locale + data.node.relationships?.field_link_interno?.fields?.slug, this.props.portale, data.node.relationships?.field_link_interno?.relationships?.field_sottodominio?.name)}">${data.node.relationships?.field_link_interno?.field_titolo_esteso}</a>`
        } else if (data.node?.field_link_esterno && data.node?.field_link){
            return `<a href="${data.node?.field_link?.uri}">${data.node?.field_titolo_link ? data.node?.field_titolo_link : data.node?.field_link?.title}</a>`
        }
    }


    render() {
        /* Purtroppo una volta renderizzato con un certo numero di giorni, quando si cambia mese il numero di
           giorni non cambia più (28, 30 o 31). Se invece si usa componentDidUpdate si risolve questo problema,
           ma si sovrappongono i render di tiny-slider che creano strati di html in più ogni volta.

        let days = Array.from(Array(this.state.moment.daysInMonth()).keys()); <-- array dinamico in base al mese

           Quindi si è optato per utilizzare un array fisso di giorni, ovviamente 31, nel caso di mesi di 30
           giorni l'ultimo elemento dell'agenda sarà il 1 del mese successivo.
        */
        let days = Array.from(Array(31).keys()); // <-- array statico di 31 elementi

        if (this.props.allerta)
            return (
                <section className="mb-4">
                    <h4 className="border-bottom-custom">Agenda</h4>

                    <div className="agenda-custom">
                        <nav className="pagination-wrapper" aria-label="Navigazione Agenda Mesi">
                            <ul className="pagination">
                                <li className="page-item">
                                    <a className="page-link" style={{"cursor": "pointer"}}
                                       onClick={event => this.previous()}>
                                        <SvgIconDPC name='chevron-left'/>
                                        <span className="sr-only">Mese precedente</span>
                                    </a>
                                </li>
                                <li className="page-item active">
                                <span className="d-inline-block">
                                    {this.state.moment.format("MMMM YYYY")}
                                </span>
                                </li>
                                <li className="page-item">
                                    <a className="page-link" style={{"cursor": "pointer"}}
                                       onClick={event => this.next()}>
                                        <span className="sr-only">Mese successivo</span>
                                        <SvgIconDPC name='chevron-right'/>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <ul className="nav nav-tabs tiny-slider-agenda-custom tiny-slider-agenda-custom-col-8"
                            id="agendaTab" role="tablist">
                            {
                                days.map(i => {
                                    let day = this.state.moment.clone().add(i, "days");
                                    if (this.props.eventi.edges
                                        .filter(e => moment(e.node.filed_data_evento).isAfter(this.lastYear), "day")
                                        .find(e => moment(e.node.field_data_evento).isSame(day, "date")))
                                        return (
                                            <li className="nav-item">
                                                <a data-toggle="tab" role="tab" aria-selected="false"
                                                   id={"agn-tab-" + day.format("YYYYMMDD")}
                                                   href={"#agn-cnt-" + day.format("YYYYMMDD")}
                                                   aria-controls={"agn-cnt-" + day.format("YYYYMMDD")}
                                                   aria-disabled="false"><span>{day.format("ddd D")}</span></a>
                                            </li>
                                        )
                                    return (
                                        <li className="nav-item">
                                            <a data-toggle="tab" role="tab"
                                               id={"agn-tab-" + day.format("YYYYMMDD")}
                                               href={"#agn-cnt-" + day.format("YYYYMMDD")}
                                               aria-controls={"agn-cnt-" + day.format("YYYYMMDD")}
                                               aria-selected="false" aria-disabled="true"
                                               className="disabled" tabIndex="-1"><span>{day.format("ddd D")}</span></a>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                        <div className="tab-content" id="agendaTabContent">
                            {

                                days.map(i => {
                                    let day = this.state.moment.clone().add(i, "days");
                                    let eventi = this.props.eventi.edges.filter(e => moment(e.node.field_data_evento).isSame(day, "date"));
                                    if (eventi.length) {
                                        return (
                                            <div className="tab-pane fade" role="tabpanel"
                                                 id={"agn-cnt-" + day.format("YYYYMMDD")}
                                                 aria-labelledby={"agn-tab-" + day.format("YYYYMMDD")}>
                                                <div className="row">
                                                    {
                                                        eventi.map(e => {
                                                            return (
                                                                <div className="col-12">
                                                                    {/* <h5>{moment(e.node.field_data_evento).format("HH:mm")}</h5> */}
                                                                    <h5>{e.node.field_luogo}</h5>
                                                                    <h6>{e.node.field_titolo_esteso}</h6>
                                                                    {/* <div>{e.node.field_titolo_esteso}</div> */}
                                                                    <div
                                                                        dangerouslySetInnerHTML={{__html: e.node.body?.processed}}/>
                                                                    {((e.node.relationships.field_allegati && e.node.relationships.field_allegati.length > 0)
                                                                        || (e.node.relationships?.field_link_interno || e.node?.field_link)) &&
                                                                        <ul className="it-list">
                                                                            {(e.node.relationships?.field_link_interno || e.node?.field_link) &&
                                                                                <li dangerouslySetInnerHTML={{__html: this.getLink(e)}}/>
                                                                            }
                                                                            {e.node.relationships.field_allegati && e.node.relationships.field_allegati.length > 0 &&
                                                                            <AllegatoDPC
                                                                                titolo={e.node.relationships.field_allegati[0].title}
                                                                                descrizione={e.node.relationships.field_allegati[0].field_allegato?.description}
                                                                                dimension={e.node.relationships.field_allegati[0].relationships?.field_allegato?.filesize}
                                                                                slug={e.node.relationships.field_allegati[0].relationships?.field_allegato?.localFile?.publicURL}
                                                                                extension={e.node.relationships.field_allegati[0].relationships?.field_allegato?.localFile?.extension}
                                                                            />
                                                                            }
                                                                        </ul>
                                                                    }

                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className="tab-pane fade" role="tabpanel"
                                                 id={"agn-tab-" + day.format("YYYYMMDD")}
                                                 aria-labelledby={"agn-tab-" + day.format("YYYYMMDD")}>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>

                </section>);


        return (
            <section className="container">
                <h4>Agenda</h4>
                <div className={`px-custom`}>
                    <div className="agenda-custom">
                        <nav className="pagination-wrapper" aria-label="Navigazione Agenda Mesi">
                            <ul className="pagination">
                                <li className="page-item">
                                    <a className="page-link" style={{"cursor": "pointer"}}
                                       onClick={event => this.previous()}>
                                        <SvgIconDPC name='chevron-left'/>
                                        <span className="sr-only">Mese precedente</span>
                                    </a>
                                </li>
                                <li className="page-item active">
                                    <span className="d-inline-block">
                                        {this.state.moment.format("MMMM YYYY")}
                                    </span>
                                </li>
                                <li className="page-item">
                                    <a className="page-link" style={{"cursor": "pointer"}}
                                       onClick={event => this.next()}>
                                        <span className="sr-only">Mese successivo</span>
                                        <SvgIconDPC name='chevron-right'/>
                                    </a>
                                </li>
                            </ul>
                        </nav>
                        <ul className="nav nav-tabs tiny-slider-agenda-custom tiny-slider-agenda-custom-col-12"
                            id="agendaTab" role="tablist">
                            {
                                days.map(i => {
                                    let day = this.state.moment.clone().add(i, "days");
                                    if (this.props.eventi.edges
                                        .filter(e => moment(e.node.filed_data_evento).isAfter(this.lastYear), "day")
                                        .find(e => moment(e.node.field_data_evento).isSame(day, "date")))
                                        return (
                                            <li className="nav-item">
                                                <a data-toggle="tab" role="tab" aria-selected="false"
                                                   id={"agn-tab-" + day.format("YYYYMMDD")}
                                                   href={"#agn-cnt-" + day.format("YYYYMMDD")}
                                                   aria-controls={"agn-cnt-" + day.format("YYYYMMDD")}
                                                   aria-disabled="false"><span>{day.format("ddd D")}</span></a>
                                            </li>
                                        )
                                    return (
                                        <li className="nav-item">
                                            <a data-toggle="tab" role="tab"
                                               id={"agn-tab-" + day.format("YYYYMMDD")}
                                               href={"#agn-cnt-" + day.format("YYYYMMDD")}
                                               aria-controls={"agn-cnt-" + day.format("YYYYMMDD")}
                                               aria-selected="false" aria-disabled="true"
                                               className="disabled" tabIndex="-1"><span>{day.format("ddd D")}</span></a>
                                        </li>
                                    );
                                })
                            }
                        </ul>
                        <div className="tab-content" id="agendaTabContent">
                            {

                                days.map(i => {
                                    let day = this.state.moment.clone().add(i, "days");
                                    let eventi = this.props.eventi.edges.filter(e => moment(e.node.field_data_evento).isSame(day, "date"));
                                    if (eventi.length) {
                                        return (
                                            <div className="tab-pane fade" role="tabpanel"
                                                 id={"agn-cnt-" + day.format("YYYYMMDD")}
                                                 aria-labelledby={"agn-tab-" + day.format("YYYYMMDD")}>
                                                <div className="row">
                                                    {
                                                        eventi.sort(function (a, b) {
                                                            // Turn your strings into dates, and then subtract them
                                                            // to get a value that is either negative, positive, or zero.
                                                            return new Date(a.node.field_data_evento) - new Date(b.node.field_data_evento);
                                                        }).map(e => {
                                                            return (
                                                                <div className="col-12">
                                                                    {/* <h5>{moment(e.node.field_data_evento).format("HH:mm")}</h5> */}
                                                                    <h5>{e.node.field_luogo}</h5>
                                                                    <h6>{e.node.field_titolo_esteso}</h6>
                                                                    {/* <div>{e.node.field_titolo_esteso}</div> */}
                                                                    <div
                                                                        dangerouslySetInnerHTML={{__html: e.node.body?.processed}}/>
                                                                    {((e.node.relationships.field_allegati && e.node.relationships.field_allegati.length > 0)
                                                                        || (e.node.relationships?.field_link_interno || e.node?.field_link)) &&
                                                                        <ul className="it-list">
                                                                            {(e.node.relationships?.field_link_interno || e.node?.field_link) &&
                                                                            <li dangerouslySetInnerHTML={{__html: this.getLink(e)}}/>
                                                                            }
                                                                            {e.node.relationships.field_allegati && e.node.relationships.field_allegati.length > 0 &&
                                                                            <AllegatoDPC
                                                                                titolo={e.node.relationships.field_allegati[0].title}
                                                                                descrizione={e.node.relationships.field_allegati[0].field_allegato?.description}
                                                                                dimension={e.node.relationships.field_allegati[0].relationships?.field_allegato?.filesize}
                                                                                slug={e.node.relationships.field_allegati[0].relationships?.field_allegato?.localFile?.publicURL}
                                                                                extension={e.node.relationships.field_allegati[0].relationships?.field_allegato?.localFile?.extension}
                                                                            />}
                                                                        </ul>
                                                                    }

                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className="tab-pane fade" role="tabpanel"
                                                 id={"agn-tab-" + day.format("YYYYMMDD")}
                                                 aria-labelledby={"agn-tab-" + day.format("YYYYMMDD")}>
                                            </div>
                                        )
                                    }
                                })
                            }
                        </div>
                    </div>
                </div>
            </section>
        );
    }
}
